// extracted by mini-css-extract-plugin
module.exports = {"credit":"credit--3hDzO","icon":"icon--37pzE","name":"name--3ySxx"};